"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var DebouncedSearch = /*#__PURE__*/function () {
  /**
   * A Debounce search permit to trigger a callback only the user has finish to type a word
   *
   * @param callback the callback to call when the user finished to type
   * @param callbackWaiting a callback which return true if there will be a search, false otherwise
   * @param timeoutTime the time of timeout between each updated values (300ms by default)
   */
  function DebouncedSearch(callback) {
    var callbackWaiting = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
    var firstValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    var timeoutTime = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 300;
    (0, _classCallCheck2.default)(this, DebouncedSearch);
    this.callback = callback;
    this.callbackWaiting = callbackWaiting;
    this.timeoutTime = timeoutTime;
    this.storedValue = firstValue;
    this.update = this.update.bind(this);
  }
  /**
   * Update the debounce search
   *
   * @param value The value to update
   * @return {boolean} true if there will be a call to the callback, false otherwise
   */


  (0, _createClass2.default)(DebouncedSearch, [{
    key: "update",
    value: function update(value) {
      var _this = this;

      if (this.timeout) {
        clearTimeout(this.timeout);
      }

      if (this.storedValue === value) {
        // If the value has not change since the last callback, do nothing and return false
        this.callbackWaiting(false);
        return false;
      }

      this.timeout = setTimeout(function () {
        _this.storedValue = value;

        _this.callback(value);

        _this.callbackWaiting(false);
      }, this.timeoutTime); // The value will change => return true

      this.callbackWaiting(true);
      return true;
    }
  }]);
  return DebouncedSearch;
}();

var _default = DebouncedSearch;
exports.default = _default;
//# sourceMappingURL=DebouncedSearch.js.map